import { ErrorAlert, Loading, Meter, PageHeader } from "../../layout/secure/common";
import useUsage from "./use-usage";

function Users() {
  const { data, error, load } = useUsage();
  if (!data && !error) return <Loading label="Loading product users" />;
  const users = data?.users || {};
  return (
    <>
      <PageHeader title="Users" description="Licensed product users can build, administer, or analyze surveys. Responders never consume these seats." />
      <ErrorAlert error={error} onRetry={load} />
      <section className="fera-panel">
        <div className="fera-panel-heading">
          <div><p className="fera-eyebrow">Product access</p><h2>Authorized users</h2></div>
          <span>{users.remaining ?? "Unlimited"} remaining</span>
        </div>
        <Meter label="Active and pending users" value={(users.active || 0) + (users.pendingInvitations || 0)} maximum={users.authorized} />
        <p className="text-muted mt-4 mb-0">Manage product users from your Feradel License account. People who only answer a survey are intentionally excluded.</p>
      </section>
    </>
  );
}

export default Users;

